module.exports = __webpack_public_path__ + "nc_static/media/service_contract_add.03483473.svg";